/**
 * 大数据埋点系统
 **/
import store from '@/store/index';
import utils from '@/utils/common';
import config from '@/config/user.env';
import _ from 'lodash';
const PAGE_TYPE = 2; // 统一权限 resourceType, 2指的是页面
class BigDataLog {
    constructor() {
        this.mainApi = config.bigDataLogUrl + '/api/2.0/send_main_message';
        this.detailApi = config.bigDataLogUrl + '/api/2.0/send_detail_message';
        this.moduleName = '';
        this.childModuleName = '';
        this.userName = '';
        this.browserInfo = {};
        this.screenInfo = {};
    }

    init(moduleName, childModuleName) {
        this.moduleName = moduleName;
        this.childModuleName = childModuleName;
        this.browserInfo = this.getBrowserInfo();
        this.screenInfo = this.getScreenInfo();
    }
    getBrowserInfo() {
        const Sys = {
            platform: window.navigator.platform,
            userAgent: window.navigator.userAgent,
            language: window.navigator.language,
            appPlatform: window.navigator.appVersion,
            appVersion: window.navigator.buildID
        };
        const ua = window.navigator.userAgent.toLowerCase();
        const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
        const m = ua.match(re);
        if (m[0] && m[1]) {
            Sys.appCodeName = m[1].replace(/version/, "'safari");
            Sys.appName = m[0];
        }
        return Sys;
    }
    getScreenInfo() {
        return {
            availWidth: window.screen.availWidth,
            availHeight: window.screen.availHeight,
            width: window.screen.width,
            height: window.screen.height,
            colorDepth: window.screen.colorDepth,
            pixelDepth: window.screen.pixelDepth
        };
    }
    getNetworkType() {
        let netType = 'wifi';
        if (window.navigator.connection && window.navigator.connection.effectiveType) {
            netType = navigator.connection.effectiveType;
        }
        return netType;
    }
    getMainMessage() {
        return {
            userName: this.userName,
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo
        };
    }
    getDetailMessage(modelInfo = {}) {
        return {
            userName: this.userName,
            moduleName: this.moduleName,
            childModuleName: this.childModuleName,
            clientDate: utils.formatDateTime(new Date()),
            href: window.location.href,
            ...this.screenInfo,
            ...this.browserInfo,
            ...modelInfo
        };
    }
    sendMainMessage() {
        // 必填信息不为空才提交
        if (!this.moduleName) {
            return false;
        }
        this.userName = store.state.user.user.userCode;
        // 注意 userCode 在 store 存放的位置
        utils.ajax({
            url: this.mainApi,
            data: {
                appName: config.bigDataLogAppName,
                topicName: 'request_data_main_log',
                message: JSON.stringify(this.getMainMessage())
            },
            type: 'POST',
            success: function (data) { }
        });
    }
    sendDetailMessage(modelInfo = {}) {
        // 必填信息不为空才提交
        if (!this.moduleName || !modelInfo.model_name1) {
            return false;
        }
        // 注意 userCode 在 store 存放的位置

        utils.ajax({
            url: this.detailApi,
            data: {
                appName: config.bigDataLogAppName,
                topicName: 'request_data_detail_log',
                message: JSON.stringify(this.getDetailMessage(modelInfo))
            },
            type: 'POST',
            success: function (data) { }
        });
    }
    sendDetailMessageByKey(key) {
        if (!key || !window.bigDataConfig) {
            return false;
        }
        let names = window.bigDataConfig[key];
        // 匹配不到埋点数据取消请求
        if (!names) {
            return false;
        }
        const params = {};
        if (typeof names === 'string') {
            names = names.split(',');
        }
        names.forEach((name, index) => {
            params['model_name' + (index + 1)] = name;
        });
        this.sendDetailMessage(params);
    }
    sendDetailMessageOfRoute(fullPath) {
        let model_name1 = '';
        let model_name2 = '';
        let model_name3 = '';
        let matched = false;

        store.getters.menus.forEach(item => {
            if (item.resourceType === PAGE_TYPE && !model_name1) {
                model_name1 = item.frontUrl === fullPath ? item.resourceName : '';
                matched = true;
            } else {
                const matchedSubItem = item.subResources.find(
                    subItem => subItem.resourceType === PAGE_TYPE && subItem.frontUrl === fullPath
                );
                if (!matchedSubItem) {
                    const isItem = this.getDeepMenuSubItem(item.subResources, fullPath);
                    // 需要判断是否找到，这里是for循环
                    isItem && (model_name1 = item.resourceName);
                    isItem && (model_name2 = isItem[0].resourceName);
                    isItem && (model_name3 = isItem[1].resourceName);
                    matched = true;
                }
                if (matchedSubItem) {
                    model_name1 = item.resourceName;
                    model_name2 = matchedSubItem.resourceName;
                    matched = true;
                }
            }
        });
        if (matched) {
            this.sendDetailMessage({ model_name1, model_name2, model_name3 });
        }
    }
    // 获取多级菜单
    getDeepMenuSubItem(item, fullPath, _items = []) {
        const _its = _.cloneDeep(_items);
        let all = [];
        const matchedSubItem = item.find(subItem => subItem.resourceType === PAGE_TYPE && subItem.frontUrl === fullPath);
        if (matchedSubItem) {
            // 找到菜单就返回
            _its.push(matchedSubItem);
            return _its;
        }

        item.forEach(it => {
            if (it.subResources) {
                const _it = _.cloneDeep(_items);
                _it.push(it);
                const newItem = this.getDeepMenuSubItem(it.subResources, fullPath, _it);
                if (newItem?.length) {
                    // 先记录前面的层级数据 并找到当前菜单
                    all = newItem;
                }
            }
        });
        if (all?.length) {
            // 找到有数据就返回
            return all;
        }
    }

    sendErrorMessage(errInfo = {}) { }
}
export default new BigDataLog();
